<template>
  <div>
    <div>
      <div :class="isChecked==-1?'edit-header checked-dashed':'edit-header'" @click="checkEdit">
        <div class="header-top">
          <div class="edit-title">{{ titleData.title }}</div>
          <div class="edid-but" >{{ titleData.qaDesc}}</div>
        </div>
        <div class="header-bot" v-if="isChecked==-1" @click="editTit">
          <img style="width: 20px" src="./../assets/img/edit.png" alt="" />
          <div>编辑</div>
        </div>
      </div>

      <div  :class="isChecked==index?'content checked-dashed':'content'" v-for="(item, index) in dataList" :key="index" >
        <div class="page-section">
          <div  class="page-section-title">

            {{ index + 1 }}. {{ item.questionDesc }}({{item.questionType == 1?'单选':'多选'}})
          </div>
          <div v-if="item.questionType == 1"  @click.stop="changeID(index)">
            <ul class="ul-sty"
              v-for="(cItem, idx) in item.optionsList"
              :key="idx"
            >
              <span class="round-sty"></span>
              <li class="li-sty" :name="cItem.optionsCode">
                {{ cItem.optionsCode }}、{{ cItem.optionsDesc }}
              </li>

            </ul>
            <div class="checkNav" v-if="isChecked==index">
              <div class="header-bot">
                <img style="width: 20px" src="./../assets/img/edit.png" alt="" />
                <div @click="editOption(item)">编辑</div>
              </div>
              <div class="header-bot">
                <img style="width: 20px" src="./../assets/img/edit.png" alt="" />
                <div @click="removeOption(item)">删除</div>
              </div>
            </div>
          </div>

          <div v-if="item.questionType == 2" @click.stop="changeID(index)">
            <ul class="ul-sty"
              v-for="(cItem, idx) in item.optionsList"
              :key="idx" >
              <span class="round-sty round-sty2"></span>
              <li class="li-sty" shape="square" :name="cItem.optionsCode"
                >{{ cItem.optionsCode }}、{{ cItem.optionsDesc }}</li>
            </ul>
            <div class="checkNav" v-if="isChecked==index">
              <div class="header-bot">
                <img style="width: 20px" src="./../assets/img/edit.png" alt="" />
                <div @click="editOption(item)">编辑</div>
              </div>
              <div class="header-bot">
                <img style="width: 20px" src="./../assets/img/edit.png" alt="" />
                <div  @click="removeOption(item)">删除</div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <van-button icon="plus" plain type="info" @click="addTopis"
        >添加题目</van-button
      >
    </div>
    <van-popup
      :overlay="false"
      v-model="isShowContent"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <div class="header2">
        <van-nav-bar
          title="问卷编辑"
          left-text="返回"
          left-arrow
          @click-left="goBack"
        />
      </div>
      <div class="add-sty">添加题型</div>
      <div class="grid-sty">
        <van-grid>
          <van-grid-item
            v-for="(item, index) in moduleList"
            :icon="item.img"
            :text="item.name"
            :key="index"
            :to="{path:item.path,query:{name:item.name,id:$route.query.typeId}}"
          >
            <!-- <template>
            <img class="module-img" @click="checkUp(item)" :src="item.img" alt="" />
          </template>
          <span class="module-span">{{ item.name }}</span> -->
          </van-grid-item>
        </van-grid>
      </div>
    </van-popup>
  </div>
</template>
<script>
import URL from '@/api/api'

export default {
  data() {
    return {
      isShowContent: false,
      radio: "",
      active:'',
      typeId: '',
      titleData: {},
      result: [],
      isChecked:-1,
      dataList: [
        // {
        //   id: 1,
        //   questionDesc: "你叫什么名字",
        //   questionType: "1",
        //   optionsList: [
        //     {
        //       id: 1,
        //       questionId: 1,
        //       optionsCode: "A",
        //       optionsDesc: "asdf",
        //       delFlag: "0",
        //       createBy: null,
        //       createTime: null,
        //       modifyBy: null,
        //       modifyTime: null,
        //     },
        //     {
        //       id: 2,
        //       questionId: 1,
        //       optionsCode: "B",
        //       optionsDesc: "啊你说什么",
        //       delFlag: "0",
        //       createBy: null,
        //       createTime: null,
        //       modifyBy: null,
        //       modifyTime: null,
        //     },
        //   ],
        //   answers: null,
        // }
      ],
      moduleList: [
        {
          id:null,
          name: "单选题",
          img: require(`./../assets/img/one.png`),
          path: "/addQuestion",
        },
        {
          id:null,
          name: "多选题",
          img: require(`./../assets/img/many.png`),
          path: "/addQuestion",
        },
      ],
    };
  },
  mounted(){
    let isBack= this.$route.query.isBack
    this.typeId = this.$route.query.typeId
    this.findQaType()
    this.getQuestions()
    if(isBack==1){
      this.isChecked=this.dataList.length-1
      this.$nextTick(() => {
        var divContent=document.getElementById("content")
        divContent.scrollTop = divContent.scrollHeight;
      });
    }
  },
  methods: {
    editOption(item){
      this.$router.push({ path: "/addQuestion", query: { data: item, id:this.typeId }});
    },
    removeOption(item){
      this.$fetchGet(URL.removeOption.url, {"questionId": item.id}).then(res=>{
        if (res.data.code == 20000) {
          this.findQaType()
          this.getQuestions()
        }
      })
    },
    checkEdit() {
      this.isChecked=-1
    },
    editTit() {
      this.$router.push({ path: "/editTitleDemo", query: { data: this.titleData }});
    },
    findQaType(){
      this.$fetchGet(URL.findQaType.url, {"id": this.typeId}).then(res => {
        if (res.data.code == 20000) {
           this.titleData = res.data.data
        }
      })
    },
    //查询单个问卷所有问题
    getQuestions() {
      let data={
          openid:localStorage.getItem("openid"),
          typeId:this.typeId
        }
      this.$fetchGet(URL.oneQuestionnaire.url, data).then(res => {
        this.dataList = res.data.data
      })
    },
    addTopis() {
      this.isShowContent = true;
    },
    goBack() {
      this.isShowContent = false;
    },
    changeID(index){
      this.isChecked=index
    }
  },
};
</script>
<style scoped>
.checked-dashed {
  border: 1px dashed #1989fa;
}
.header-top {
  padding: 15px;
  background: #fff;
}
.edit-title {
  font-size: 0.35rem;
  font-weight: 600;
}
.edid-but {
  margin-top: 20px;
  font-size: 0.28rem;
  color: #646566;
}
.header-bot {
  text-align: center;
  padding: 7px;
  line-height: 15px;
  border-top: 1px solid #e4e7ed;
  font-size: 0.2rem;
  color: #666;
  background: #f7f8fa;
}

.content {
  width: 95%;
  margin: 10px auto;
  padding: 10px;
  background: #fff;
  border-radius: 5px;
  font-size: 0.3rem;
}

.van-button--info {
  width: 80%;
  margin: 20px auto;
  left: 50%;
  transform: translateX(-50%);
  border: 1px dashed;
}
.add-sty {
  font-size: 0.3rem;
  padding: 10px;
}
.van-popup {
  background-color: #f2f3f5;
}
.grid-sty {
  width: 95%;
  margin: auto;
  background: #fff;
  border-radius: 5px;
}
.van-grid {
  width: 95%;
  margin: auto;
}
.checkNav{
  display: flex;
  margin-top: 15px;
  background: #f7f8fa;
}
.ul-sty{
  display: flex;
      padding-top: 10px;
    line-height: 22px;
}
.round-sty{
  width: 20px;
  height: 20px;
  display: block;
  border: 1px solid #c8c9cc;
  border-radius: 50%;
}
.round-sty2{
  border-radius: 0;
}
.li-sty{
  padding-left: 10px;
}
</style>
